import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/regra_premio/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/regra_premio/insert', data);
  },
  async update(data) {
    return await http.post('/api/regra_premio/update', data);
  },
  async delete(data) {
    return await http.post('/api/regra_premio/delete', data);
  }
};